// src/utils/deviceUtils.js

// Canonical Samsung / Galaxy detection helper
export function isSamsungGalaxy() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  return /Samsung|SM-|SAMSUNG/i.test(ua);
}
